var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"siweixunlianke"},[_c('PublicCert',{attrs:{"logo":_vm.Logo10,"type":'jy-tt',"color":'#a00d10'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }